import { BaseRouteService } from "./BaseRouteService";

export class InventoryService extends BaseRouteService {
    public async openInventory(): Promise<{ inventory: string[] }> {
        try {
            // Uses the inherited getJsonApi method from BaseRouteService
            return await this.getJsonApi<{ inventory: string[] }>("inventory/open-inventory");
        }
        catch {
            throw new Error("Failed to open inventory");
        }
    }
}
